import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, ScrollText, Landmark, LifeBuoy, ClipboardList, PackageSearch } from "lucide-react";
import { Link } from "react-router-dom";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy } from "@/contexts/LanguageContext";

const COPY = {
  en: { h: "Platform Administration", p: "Manage users, lenders, schemes and audit trails.", users: "Total users", opps: "Active opportunities", lenders: "Verified lenders", apps: "Applications", borrowers: "Borrowers", griev: "Open grievances" },
  hi: { h: "मंच प्रशासन", p: "उपयोगकर्ता, ऋणदाता, योजनाएँ और ऑडिट रिकॉर्ड प्रबंधित करें।", users: "कुल उपयोगकर्ता", opps: "सक्रिय अवसर", lenders: "सत्यापित ऋणदाता", apps: "आवेदन", borrowers: "उधारकर्ता", griev: "खुली शिकायतें" },
};

function StatCard({ icon: Icon, label, value, to, test }) {
  return (
    <Link to={to} data-testid={test} className="p-6 rounded-lg border border-slate-200 bg-white card-hover flex items-start gap-4">
      <div className="w-10 h-10 rounded-md bg-slate-900 grid place-items-center text-white"><Icon className="w-5 h-5" /></div>
      <div className="min-w-0 flex-1">
        <div className="text-xs uppercase tracking-widest text-slate-500">{label}</div>
        <div className="mt-1 text-2xl font-bold text-slate-900 brand-heading">{value ?? "—"}</div>
      </div>
    </Link>
  );
}

export default function AdminDashboard() {
  const [s, setS] = useState({});
  const c = useCopy(COPY);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <div><h1 className="text-2xl sm:text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1><p className="text-slate-600 mt-1 text-sm">{c.p}</p></div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <StatCard icon={Users} label={c.users} value={s.total_users} to="/admin/users" test="ad-users" />
        <StatCard icon={PackageSearch} label={c.opps} value={s.active_opportunities} to="/admin/audit" test="ad-opps" />
        <StatCard icon={Landmark} label={c.lenders} value={s.verified_lenders} to="/admin/lenders" test="ad-lenders" />
        <StatCard icon={ClipboardList} label={c.apps} value={s.applications} to="/admin/audit" test="ad-apps" />
        <StatCard icon={ScrollText} label={c.borrowers} value={s.borrowers} to="/admin/users" test="ad-borrowers" />
        <StatCard icon={LifeBuoy} label={c.griev} value={s.open_grievances} to="/admin/grievances" test="ad-griev" />
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
